import styled from '@emotion/styled'
import { breakpoints, spacing } from '../../styles/vars'
import { at } from '../../styles/utils'

export const Wrapper = styled.div`
  padding: ${spacing.mobile};
  background: rgba(0, 0, 0, 0.5);
  grid-row: 2 / 3;
  p {
    margin-bottom: 1.5em;
    line-height: 1.5em;

    &:last-child {
      margin-bottom: 0;
    }
  }
  ${at(breakpoints.laptop)} {
    padding: 1em ${spacing.mobile} 0;
    z-index: 2;
  }

  ${at(breakpoints.desktop)} {
    padding: 1.5em ${spacing.desktop} 0;
  }
`

export const StoryItem = styled.div`
  counter-reset: paragraph;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  display: ${({ visible }) => (visible ? 'block' : 'none')};

  .text p {
    counter-increment: paragraph;
    opacity: ${({ visible }) => (visible ? '1' : '0')};
    transition: opacity 1s 300ms ease-in-out;
  }
`
